import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ArrayHelper from 'foundation/array-helper';
import Scrollable from 'general/js/scrollable';
import CustomEventLeaderboardScoreCell from './custom-event-leaderboard-score-player-cell';

class CustomEventLeaderboardHoleByHoleWidget extends React.Component {
    constructor(props) {
        super(props);

        this.rootRef = React.createRef();
        this.innerRef = React.createRef();

        this.scrollable = null;
    }

    componentDidMount() {
        if (this.props.isScrollable) {
            this.scrollable = new Scrollable(
                this.rootRef.current,
                this.innerRef.current,
            );
        }
    }

    componentWillUnmount() {
        if (this.scrollable) {
            this.scrollable.destroy();
        }
    }

    renderCell(key, value = '', type = {}) {
        const typeCss = classNames({
            'is-wide': type.isWide
        });

        return <div key={key} className={`live-player-scores__cell ${typeCss}`}>{value}</div>;
    }

    getHoleScore(holePar, value){
        if(value === 0)
            return value;

        if(value > holePar)
            return `+${value-holePar}`;
        
        if(value === holePar)
            return 'E';

        if(value < holePar)
            return `-${holePar - value}`
    }

    renderPlayerPar(key, holePar, value, status) {
        const score = this.getHoleScore(holePar, value);

        return (
            <CustomEventLeaderboardScoreCell
                key={key}
                childCss={'live-player-scores__player-cell'}
                holePar={holePar}
                playerPar={score}
                status={status}
            />
        );
    }

    renderHeadLine() {
        const { holesToBePlayed } = this.props;

        return (
            <div className="live-player-scores__head">
                {
                    holesToBePlayed.map((hole, i) =>
                        this.renderCell(`h-${i}`, hole.holeNumber))
                }
            </div>
        );
    }

    renderHoleParLine() {
        const { holesToBePlayed } = this.props;

        return (
            <div className="live-player-scores__row">
                {
                    holesToBePlayed.map((hole, i) =>
                        this.renderCell(`h-${i}`, hole.holePar))
                }
            </div>
        );
    }

    renderPlayerParLine() {
        const { holesToBePlayed, scoringPlayerRound, playerSitecoreData } = this.props;

        if (!scoringPlayerRound ||
            ArrayHelper.isEmpty(scoringPlayerRound.info)
        ) {
            return (
                <div className="live-player-scores__player">
                    {
                        holesToBePlayed.map((hole) => {
                            return (
                                <div class="live-player-scores__player-cell score-cell score-cell--default score-cell--has-border">-</div>
                                )
                        })
                    }
                </div>
                );
        }

        const playerHasInfo = playerSitecoreData !== null && playerSitecoreData !== undefined && playerSitecoreData.playerStatuses !== undefined && playerSitecoreData.playerStatuses !== null && !ArrayHelper.isEmpty(playerSitecoreData.playerStatuses);

        return (
            <div className="live-player-scores__player">
                {
                    holesToBePlayed.map((hole) => {
                        const holeInfo = scoringPlayerRound.info.find((r) => r.holeId === hole.holeNumber) || null;
                        const status = playerHasInfo ? playerSitecoreData.playerStatuses.find((holeStatus) => holeStatus.hole.number === hole.holeNumber) : null;

                        const playerStatus = (status !== null && status !== undefined) ? status.status : null;
                        return this.renderPlayerPar(`p-${hole.holeNumber - 1}`, hole.holePar, holeInfo.playerPar, playerStatus);
                    })
                }
            </div>
        );
    }

    render() {
        const { scoringPlayerRound, isScrollable } = this.props;
        const stateCss = classNames({
            'is-empty': !scoringPlayerRound || ArrayHelper.isEmpty(scoringPlayerRound.info),
            'is-scrollable': isScrollable,
        });

        return (
            <div className={`live-player-scores ${stateCss}`} ref={this.rootRef}>
                <div className="live-player-scores__inner" ref={this.innerRef}>
                    <div className="live-player-scores__list">
                        {this.renderHeadLine()}
                        {this.renderHoleParLine()}
                        {this.renderPlayerParLine()}
                    </div>
                </div>
            </div>
        );
    }
}

CustomEventLeaderboardHoleByHoleWidget.propTypes = {
    scoringPlayerRound: PropTypes.object,
    scoringCourse: PropTypes.object,
    isScrollable: PropTypes.bool,
};

export default CustomEventLeaderboardHoleByHoleWidget;
